<div class="flex flex-wrap items-stretch justify-center -mx-2 gap-4" [ngClass]="{
    'sm:justify-start': halign === 'left',
    'sm:justify-end': halign === 'right'
}">
    @if(locale === 'fr') {
        <a matRipple class="qo-MainBtn" target="_blank" href="https://webforms.pipedrive.com/f/72vCIPRtXsD72MgIlHMn313jMMKYYYTgRCdXjmVTOSc0ZSeYdqQs61fKzVzVxLymUb" i18n>Contactez-nous</a>
    } 
    @else {
        <a matRipple class="qo-MainBtn" [routerLink]="NavigationService.Routes.Contact()" i18n>Contactez-nous</a>
    }
</div>
